{
  "Clear search": "清除搜尋"
}
